import { createSelector } from 'reselect';
import {
  data as dataSelector,
  data2 as data2Selector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY, PENSIONS_CRUD_OVERVIEW } from '../PensionWorkflowConstants';

export const graphPensionsSelector = createSelector(
  dataSelector,
  data => data(`${BACKEND_KEY}`) || [],
);

const pensionsSelector = createSelector(graphPensionsSelector, graphPensions =>
  graphPensions.filter(({ IsDeleted }) => !IsDeleted));

export const isEmptyStateSelector = createSelector(
  pensionsSelector,
  pensions => pensions.length <= 0,
);

export const viewIDSelector = createSelector(
  data2Selector,
  data2 => data2(`${BACKEND_KEY}.PensionStepViewID`) || PENSIONS_CRUD_OVERVIEW,
);

export default pensionsSelector;
